import React from "react";
import { useT } from "@transifex/react";
import {
  ErrorContainer,
  NavButton,
} from "../../../layouts/questionnaire-layout/styles";

interface Props {
  message: string;
}

const ErrorPage: React.FC<Props> = ({ message }) => {
  const t = useT();

  const friendlyMessages: Record<string, string> = {
    no_token: t("This survey link appears to be invalid. Please check your email for the correct link."),
    fetch_failed: t("We're having trouble loading the survey. Please try again in a moment."),
    submit_failed: t("We weren't able to submit your responses. Please try again."),
    no_questions: t("This survey doesn't have any questions to display. Please contact your care team."),
  };
  const friendly = friendlyMessages[message]
    ?? t("We're having trouble loading the survey. Please try again in a moment.");

  return (
    <ErrorContainer>
      <h2>{t("We hit a snag")}</h2>
      <p>{friendly}</p>
      <NavButton variant="primary" onClick={() => window.location.reload()}>
        {t("Try Again")}
      </NavButton>
      <p style={{ fontSize: "12px", color: "#94a3b8", marginTop: "24px" }}>
        {t("If the problem persists, please contact your care team for assistance.")}
      </p>
    </ErrorContainer>
  );
};

export default ErrorPage;
